<template>
  <aside class="layout__sidebar layout__sidebar--left">
    <form
      @submit.prevent=""
    >
      <div class="filters__section filters__section--search">
        <FormGroup class="filters__group filters__group--level-1">
          <FormItem type="search">
            <label for="shipname" class="sr-only">{{ $t('Search') }}</label>
            <input
              id="shipname"
              v-model="filters.multi"
              name="shipname"
              :class="[
                'form-item__input',
                `form-item__input--text`,
                'form-item__input--full-width',
              ]"
              type="text"
              :placeholder="`${$t('Find a ship')}`"
              @input="updateFiltersAfterUiUpdate"
            />
            <button class="form-item--search__button" @click="updateFiltersAfterUiUpdate">
              <span class="sr-only">{{ $t('Find a ship') }}</span>
              <i class="icon-search"></i>
            </button>
          </FormItem>
        </FormGroup>
      </div>
    </form>
    <br />
    <div>
      <p>{{ $t('Notice!') }}</p>
      <p>
        {{ $t('This list has been updated. ') }}
        {{ $t('If a ship has a ') }}
        <i class="icon-check" />
        {{ $t(' the ship has delivery entitlement. ') }}
        {{ $t('Ships that have not yet been rated are not shown.') }}
      </p>
    </div>
  </aside>
</template>

<script>
import FormGroup from '@/Theme/Components/02-atoms/FormGroup/FormGroup.vue';
import FormItem from '@/Theme/Components/02-atoms/FormItem/FormItem.vue';

export default {
  name: 'FilterSidebar',
  components: {
    FormGroup,
    FormItem,
  },
  data() {
    return {
      filters: {
        multi: null,
      },
    };
  },
  methods: {
    updateFiltersAfterUiUpdate() {
      this.$nextTick(() => {
        this.$store.commit('setFilters', this.filters);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.filters {
  &__section {
    transition: max-height 300ms ease-in-out;
    max-height: 1200px;
    &--hide {
      max-height: 0;
      overflow-y: hidden;
      @include media-breakpoint-up(md) {
        max-height: none;
      }
    }
    &--search {
      display: flex;
      align-items: center;
      .form-item {
        margin-bottom: 0;
      }
      > .filters__group {
        flex-shrink: 1;
        flex-grow: 1;
        flex-basis: 0;
        @include media-breakpoint-down(sm) {
          margin-bottom: 0;
        }
      }
    }
    &--filters {
      .filters__group {
        &--level-1 {
          &:first-child {
            margin-top: 2.5rem;
            @include media-breakpoint-up(md) {
              margin-top: 0;
            }
          }
        }
      }
    }
  }
}
.icon-check {
  color:#75b94e;
}
</style>
